import PhoneInputRaw from 'react-phone-input-2';
import type { FC } from 'react';
import type { PhoneInputProps } from 'react-phone-input-2';

// Vite 8 (Rolldown) does not unwrap the `.default` property of CJS bundles that set
// `__esModule: true`, so a bare default import of react-phone-input-2 returns the
// full exports object instead of the component class.  We normalise here so
// downstream code sees a stable React component regardless of the bundler.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PhoneInput = ((PhoneInputRaw as any).default ??
  PhoneInputRaw) as FC<PhoneInputProps>;
export default PhoneInput;
